import { ReviewResult } from './check';

export type StatisticByStatus = {
  [ReviewResult.fail]: number;
  [ReviewResult.pass]: number;
  [ReviewResult.warning]: number;
};

export enum ReviewCategory {
  styleReview = 'styleReview',
  safetyReview = 'safetyReview',
  claimsReview = 'claimsReview',
  brandingReview = 'brandingReview',
}

export enum DocumentReviewCategory {
  brandingReview = 'brandingReview',
}

export type StatisticsByPage = {
  [ReviewCategory.styleReview]: StatisticsByCategory;
  [ReviewCategory.safetyReview]: StatisticsByCategory;
  [ReviewCategory.claimsReview]: StatisticsByCategory;
  [ReviewCategory.brandingReview]: StatisticsByCategory;
};

export type StatisticsByCategory = {
  all: number;
  [ReviewResult.fail]: number;
  [ReviewResult.pass]: number;
  [ReviewResult.warning]: number;
};

export const COUNTABLE_STATS_CATEGORIES: (
  | ReviewCategory.safetyReview
  | ReviewCategory.styleReview
  | ReviewCategory.claimsReview
)[] = [
  ReviewCategory.safetyReview,
  ReviewCategory.styleReview,
  ReviewCategory.claimsReview,
];
